import { render, staticRenderFns } from "./UiMarketCartDetail.vue?vue&type=template&id=943c3120&"
import script from "./UiMarketCartDetail.vue?vue&type=script&lang=js&"
export * from "./UiMarketCartDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports